export const SERVICE_FEE_HELP_TEXT =
  "This fee helps cover the behind-the-scenes costs your clinic incurs in providing veterinary services through home delivery, including order processing, administrative support, and compliance costs required of your clinic.";
